import React from "react";

import { SettingsScreen } from "./Settings";

export const ProfileScreen = () => {
  return <SettingsScreen defaultSection="profile" />;
};
